module.exports = __webpack_public_path__ + "static/media/wave-4.10dffc1a.svg";